const tsaEnvConfig = () => {

  // console.log("window.config?.externalTarget", window.config?.externalTarget)

  const runMode = process.env.NODE_ENV;
  const API_BASE_URL = runMode === 'development' ? '/ApiData' : (window.isLoggedOut ? "/digital/nsa/nos/gw/troubleshooting" : '/digital/nsa/secure/gw/troubleshooting');
  const ACSS_BASE_URL = window.config?.isLoggedOut ? `${window.config?.externalTarget}/acss/nos/service/troubleshooting` : `${window.config?.externalTarget}/acss/service/troubleshooting`;

  // console.log("test runmode, isAcss : ", runMode, window?.isAcss);

  const prodApiUrls = {
    apiBaseUrl: API_BASE_URL,
    additionalInfo: `${API_BASE_URL}/other-content`,
    recentPendingCase: `${API_BASE_URL}/get-recent-pending-case`
  };

  const acssApiUrls = {
    apiBaseUrl: ACSS_BASE_URL,
    additionalInfo: `${ACSS_BASE_URL}/other-content`
  };

  const devApiUrls = {
    apiBaseUrl: API_BASE_URL,
    additionalInfo: `${API_BASE_URL}/additionalInfo.json`,
    recentPendingCase: `${API_BASE_URL}/getrecentpendingcase.json`
  };

  if (runMode === 'development') {
    return { apiUrls: devApiUrls };
  }

  if (window.config?.isAcss) {
    return { apiUrls: acssApiUrls };
  }

  return { apiUrls: prodApiUrls };
};

export default tsaEnvConfig;
